import { API } from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;

export async function uploadFile(file, kind = "generic", onProgress) {
  const uploadId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  const total = Math.ceil(file.size / CHUNK) || 1;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
    const r = await fetch(`${API}/upload/chunk`, { method: "POST", body: fd });
    if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Errore caricamento");
    onProgress?.(Math.round(((i + 1) / total) * 90));
  }
  const fd = new FormData();
  fd.append("upload_id", uploadId);
  fd.append("filename", file.name);
  fd.append("content_type", file.type || "application/octet-stream");
  fd.append("kind", kind);
  const r = await fetch(`${API}/upload/finalize`, { method: "POST", body: fd });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Errore finalizzazione");
  onProgress?.(100);
  return r.json();
}

export const fileUrl = (id) => (id ? `${API}/files/${id}` : null);

export async function streamSse(url, body, onToken) {
  const r = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!r.ok || !r.body) throw new Error("Richiesta non riuscita");
  const reader = r.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.replace(/^data: /, "").trim();
      if (!line || line === "[DONE]") continue;
      const ev = JSON.parse(line);
      if (ev.error) throw new Error(ev.error);
      if (ev.t) onToken(ev.t);
    }
  }
}
